import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
  name: 'TimeZonedDate',
  standalone: false,
})
export class TimeZonedDatePipe implements PipeTransform {
  transform(unixTimestamp: number): string {
    const utcDate = moment.utc(moment.unix(unixTimestamp));
    const userOffset = moment().utcOffset();
    return utcDate.utcOffset(userOffset).format('DD MMM YYYY HH:mm');
  }
}
